import { h } from 'preact';
import { stripEmoji } from '../utils/gift-message';
const MAX_LENGTH = 255;
export const GiftMessage = ({ title , description , value , fieldName , onChange , placeholder , className =''  })=>h('div', {
        className: `gift-wrapping__message ${className}`
    }, [
        title && h('h3', {
            className: 'gift-wrapping__step__title gift-wrapping__step__title--small'
        }, title),
        h('div', {
            className: 'gift-wrapping__message__description'
        }, description),
        h('div', {
            className: 'gift-wrapping__message__textarea-wrap'
        }, [
            h('span', {
                className: 'gift-wrapping__message__counter'
            }, `${value.length}/${MAX_LENGTH}`),
            h('textarea', {
                name: fieldName,
                'data-testid': 'gift-wrapping-message-textarea',
                placeholder,
                maxLength: MAX_LENGTH,
                value,
                onInput: (e)=>{
                    const raw = e.target.value;
                    const stripped = stripEmoji(raw);
                    if (stripped !== raw) {
                        e.target.value = stripped;
                    }
                    onChange(stripped);
                }
            })
        ])
    ]);
